import http from 'hub-http/clients/apiClient';
import { createRpcClientV2, getChirpEarlyRequestName } from 'rpc-client-utils';
import { evaluateInAppRpc } from '../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { getChirpEarlyRequest } from '../utils/earlyRequest';
import { transformToLegacyPurchaseMotionsShape } from './transformToLegacyPurchaseMotionsShape';
const authedChirpClient = createRpcClientV2({
  hubHttpClient: http
});
export const getInAppLegacyPurchaseMotionsResponse = requestedLocations => {
  const request = {
    locations: requestedLocations,
    productApiNames: []
  };
  const earlyRequestName = getChirpEarlyRequestName(Object.assign({}, evaluateInAppRpc, {
    earlyRequest: true
  }), {
    request
  });
  return getChirpEarlyRequest(earlyRequestName, () => authedChirpClient.call(evaluateInAppRpc, {
    request
  })).then(purchaseMotionsResponse => {
    return {
      locations: transformToLegacyPurchaseMotionsShape(requestedLocations, purchaseMotionsResponse)
    };
  });
};